// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-detail-attributes-tile{width:100%}.location-detail-attributes-tile .field-label{align-self:stretch;color:#6c757d;font-size:12px;font-style:normal;font-weight:400;line-height:1.2;text-shadow:0 0 0 transparent}.location-detail-attributes-tile .field-value{align-self:stretch;color:#31363a;font-size:13px;font-style:normal;font-weight:400;line-height:1.375;overflow-wrap:anywhere;word-break:break-word}", ""]);
// Exports
module.exports = exports;
